import React from "react";
import {Article} from "./components/";
import media from "styled-media-query";
import breakpoints from "Helpers/BreakpointHelper";
import {BlockContainer} from "BaseComponents/Wrappers";
import {useGlobal} from "reactn";
import {H2} from "BaseComponents/Text";
import styled from "styled-components";
import {BlockLink} from "BaseComponents/Link";

export const ArticleBlock = ({ Heading, HeadingUrl, SearchHits, LinkText, LinkUrl }) => {
	const [theme] = useGlobal("theme");
	let First = SearchHits.length == 4 ? SearchHits.splice(0, 1)[0] : null;
	return (
		SearchHits.length > 0 && (
			<BlockContainer>
				<ArticleBlockOuterWrapper>
					<Header
						inline
						margin="0 0 25px 0rem"
						marginsmall="0 0 1rem 0"
						color={theme.colors.primary}
					>
						{Heading}
					</Header>
					<Articles>
						{First && <Article {...First} fullWidth={true} />}
						<ArticleBlockWrapper>
							{SearchHits.map((article, i) => {
								return <Article {...article} key={i} />;
							})}
						</ArticleBlockWrapper>
					</Articles>
					{LinkUrl && <BlockLink text={LinkText} href={LinkUrl} />}
				</ArticleBlockOuterWrapper>
			</BlockContainer>
		)
	);
};
export const Header = styled(H2)`
	& {
		font-size: 26px;
	}
`;
export const ArticleBlockContainer = styled.div`
	background-color: ${({ theme }) => theme.colors.bg1};
	padding: 0 3rem;

	${media.lessThan(breakpoints.ipad)`
  padding: 1rem 1rem;
  
  `}
	${media.lessThan(breakpoints.mobile)`
  padding: 0;

  `}
`;
export const ArticleBlockOuterWrapper = styled.div`
	max-width: ${({ theme }) => theme.grid.outer};
	width: auto;
	padding: 0;

	${media.greaterThan(breakpoints.mobile)`
        margin: 0 auto;
        width: auto;
    `}
`;
export const Articles = styled.div`
	display: flex;
	flex-direction: column;
`;

export const ArticleBlockWrapper = styled.div`
	width: auto;
	display: flex;
	margin-top: 12px;

	${media.lessThan(breakpoints.mobile)`
        flex-direction: column;
    `}
`;
